<template>
    <div ref="queueIndicatorContainer" class="queue-indicator-container"></div>
</template>

<script setup lang="ts">
    import type { IFulfillmentGroup } from "@/data/model/FulfillmentGroup";
    import type { IOperatorFulfillment } from "@/data/model/Operator";
    import { FulfillmentQueueIndicator } from "@/operator/elements/FulfillmentQueueIndicator";
    import { onMounted, ref, watch } from "vue";

    const props = defineProps<{
        fulfillment: IOperatorFulfillment;
        group?: IFulfillmentGroup;
        currentTime: Date;
    }>();

    const queueIndicatorContainer = ref<HTMLDivElement | null>(null);
    let queueIndicator: FulfillmentQueueIndicator;

    function updateTime(date: Date) {
        queueIndicator.updateQueueIndicator(date, props.fulfillment);
    }

    // Lifecycle
    onMounted(() => {
        queueIndicator = new FulfillmentQueueIndicator(props.fulfillment);
        queueIndicator.renderTo($(queueIndicatorContainer.value!));
    });

    // Expose methods that might be needed by parent components
    watch(() => props.currentTime, updateTime);
</script>
